import React from "react";
import { CgChevronRight } from "react-icons/cg";
import { HiDocument } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import {
  ExercisesIcon,
  ProtocolsIcon,
  WorkoutsIcon,
} from "src/assets/static/icons";

const ToolsCard: React.FC = () => {
  const navigate = useNavigate();

  const tools = [
    {
      title: "Protocolos Template",
      description: "Biblioteca de Planos de Treino",
      path: "/tools/plans",
      Icon: ProtocolsIcon,
    },
    {
      title: "Treinos Template",
      description: "Biblioteca Treinos",
      path: "/tools/workout",
      Icon: WorkoutsIcon,
    },
    {
      title: "Exercícios Template",
      description: "Biblioteca de Exercícios",
      path: "/tools/exercises",
      Icon: ExercisesIcon,
    },
    {
      title: "Fomulário Anamnese",
      description: "Criar ou Vincular anamnese",
      path: "/tools/anamnese",
      Icon: HiDocument,
    },
  ];

  return (
    <div className="middle-card">
      <h4 className="card-title">Ferramentas de Consultoria</h4>
      <div className="flex flex-col space-y-3">
        {tools.map((tool, index) => (
          <button
            key={index}
            onClick={() => navigate(tool.path)}
            className="flex items-center rounded-lg bg-zinc-100 px-4 py-2 hover:bg-zinc-200 active:bg-zinc-300 dark:bg-transparent"
          >
            {tool.Icon && (
              <tool.Icon className="mr-2 text-xl text-zinc-500 dark:text-zinc-200" />
            )}
            <div className="flex flex-col">
              <h2 className="text-sm font-bold text-zinc-800 dark:text-zinc-200">
                {tool.title}
              </h2>
              <p className="text-xs font-medium text-zinc-600 dark:text-zinc-500">
                {tool.description}
              </p>
            </div>
            <CgChevronRight
              size={20}
              className="ml-auto text-zinc-800 dark:text-white"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ToolsCard;
